module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24"><path fill-rule="evenodd" d="M6 24v-3h6v3H6zm9 0v-3h6v3h-6zM3 21v-3h3v3H3zm18 0v-3h3v3h-3zM6 18v-3h3v3H6zm12 0v-3h3v3h-3zm-6-9V6H6v3h6zm9 0V6h-6v3h6zM9 15v-3H0V6h3V3h3V0h15v3h3v3h3v6h-9v3H9z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/icon_about_us_alien_small_6.svg
// module id = 1803
// module chunks = 4